import {AxiosError} from 'axios';
import {GET_CANDIDATE_PROFILE_QUERY_KEY} from 'web-library/constants/queryKeys';
import {GET_CANDIDATE_PROFILE_URL} from 'web-library/constants/apiUrls';
import {CandidateProfileResponse} from 'web-library/models/AccountManagementConfiguration';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: CandidateProfileResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  enabled: boolean;
}

export const useGetCandidateProfile = ({onError, onSuccess, uuid, enabled}: Input) => {
  const getCandidateProfile = async () => {
    const res = await axiosClient.get<CandidateProfileResponse>(GET_CANDIDATE_PROFILE_URL(uuid));

    return res.data;
  };

  return useCustomQuery([GET_CANDIDATE_PROFILE_QUERY_KEY, uuid], getCandidateProfile, {
    onSuccess,
    onError,
    enabled,
  });
};
